import React, { useEffect, useState } from 'react'
import { DataGrid } from '@mui/x-data-grid'
import { apiClient } from 'utils/api/apiClient'

export default function UserSummaryTable() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [periodType, setPeriodType] = useState('monthly')

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      try {
        const { data } = await apiClient.get('/api/users/summary')
        if (!data) return

        const summaryData = data[periodType] || []
        const mapped = summaryData.map((item, index) => ({
          id: index, // required by DataGrid
          period: item.period,
          usersAdded: item.usersAdded,
          runningTotal: item.runningTotal,
        }))
        setRows(mapped)
      } catch (err) {
        console.error('Failed to load user summary:', err.response || err)
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [periodType])

  const columns = [
    {
      field: 'period',
      headerName: 'Change Over Time',
      flex: 1,
      sortable: true,
    },
    { field: 'usersAdded', headerName: 'Users Added', flex: 1, type: 'number' },
    {
      field: 'runningTotal',
      headerName: 'Running Total',
      flex: 1,
      type: 'number',
    },
  ]

  return (
    <div>
      {/* Period selector */}
      <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
        <button
          onClick={() => setPeriodType('weekly')}
          disabled={periodType === 'weekly'}
        >
          Weekly
        </button>
        <button
          onClick={() => setPeriodType('monthly')}
          disabled={periodType === 'monthly'}
        >
          Monthly
        </button>
        <button
          onClick={() => setPeriodType('quarterly')}
          disabled={periodType === 'quarterly'}
        >
          Quarterly
        </button>
      </div>

      <div style={{ height: 500, width: '100%' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 50]}
          initialState={{
            sorting: {
              sortModel: [{ field: 'period', sort: 'desc' }],
            },
          }}
        />
      </div>
    </div>
  )
}
